export default __webpack_public_path__ + "5c62e0ac21f57c419f00337f65b38b12.png";